<template>
  <!-- <div class="container-fluid"> -->
  <div>
    <div class="row">
      <div class="col-lg-6">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              123云盘链接管理(删除不能提取的云盘链接)
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <label for="exampleInputPassword1" style="font-size: 14px"
              >需要删除的数据库链接：</label
            >
            <base-input
              type="text"
              placeholder="请输入素材链接"
              style="margin-top: 4px"
              v-model="link"
            >
            </base-input>
            <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="handleDelete"
                >删除</base-button
              >
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6">
        <card
          type="tasks"
          class="col-sm"
          style="height: auto; padding-bottom: 30px; overflow-x: auto"
        >
          <div
            class="badge badge-primary"
            style="font-size: 16px; margin-top: 6px; padding: 6px"
          >
            公告管理(只显示第一条公告)
          </div>
          <div style="margin-top: 26px">
            <base-table :data="tableData" :columns="columns">
              <template slot="columns">
                <th>id</th>
                <th style="width: 80px">颜色</th>
                <th>内容</th>
                <th>添加时间</th>
                <th style="width: 100px" class="text-center">操作</th>
              </template>
              <template slot-scope="{ row }">
                <td>{{ row.id }}</td>
                <td>{{ colorFun(row.color) }}</td>
                <td>{{ row.content }}</td>
                <td>{{ changeDateFormat(row.add_time) }}</td>
                <td class="td-actions ext-center">
                  <!-- <base-button type="info" size="sm"  icon >
                    <i class="tim-icons icon-single-02" ></i>
                  </base-button> -->
                  <base-button
                    type="success"
                    style="margin-left: 6px"
                    size="sm"
                    icon
                    @click="editNotice(row.id, row.color, row.content)"
                  >
                    <i
                      style="color: #ffffff"
                      class="tim-icons icon-settings"
                    ></i>
                  </base-button>
                  <base-button
                    type="danger"
                    style="margin-left: 6px"
                    size="sm"
                    icon
                    @click="deleteNotice(row.id)"
                  >
                    <i
                      style="color: #ffffff"
                      class="tim-icons icon-simple-remove"
                    ></i>
                  </base-button>
                </td>
              </template>
            </base-table>
            <div style="display: flex; justify-content: flex-end">
              <base-button
                style="margin-top: 56px"
                native-type="submit"
                type="primary"
                @click="handleAddNotice"
                >添加公告</base-button
              >
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              123云盘管理(到期之前需要点击自动重新登陆)
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <div>
              <label for="exampleInputPassword1" style="font-size: 16px"
                >云盘账号：</label
              ><span style="font-size: 16px">{{ username }}</span>
            </div>

            <div>
              <label
                for="exampleInputPassword1"
                style="font-size: 16px; margin-top: 6px"
                >登录过期时间：</label
              ><span style="font-size: 16px">{{
                changeDateFormat(expired)
              }}</span>
            </div>

            <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="updata123yunpan"
                >点击重新登录云盘</base-button
              >
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              动态代理ip管理
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <textarea
              ref="myTextarea"
              v-model="ipTextareaValue"
              style="padding: 0"
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>

            <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="updateIp"
                >更新动态ip</base-button
              >
            </div>
          </div>
        </card>
      </div>

      <!-- <div class="col-lg-6">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              店铺续费图片管理
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="updata123yunpan"
                >点击上传图片</base-button
              >
            </div>
          </div>
        </card>
      </div> -->

      <div class="col-lg-6">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              店铺续费图片管理(上传图片二维码)
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <div class="banner-left">
              <img class="banner-qrcode" :src="payImg" alt="二维码" />
              <div class="banner-qr-text">当前续费图片使用中二维码</div>
            </div>
            <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="triggerFileUpload"
              >
                点击上传图片
              </base-button>
              <!-- 隐藏的文件上传 input -->
              <input
                type="file"
                ref="fileInput"
                style="display: none"
                accept="image/*"
                @change="handleImageUpload"
              />
            </div>
          </div>
        </card>
      </div>


      <div class="col-lg-6">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              其他配置控制
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <div class="huaban_type_header">
              <div>是否区分花瓣第三方：</div>
              <div><el-tooltip
                  :content="
                    huaban_type === '1' ? '不区分自营/第三方' : '区分自营/第三方'
                  "
                  placement="top"
                >
                <!-- v-model="row.state" -->
                  <el-switch
                  v-model="huaban_type"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="2"
                    @change="changeHuaBanState"
                  >
                  </el-switch>
                </el-tooltip></div>
            </div>

            <!-- <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="updateIp"
                >更新动态ip</base-button
              >
            </div> -->
          </div>
        </card>
      </div>

    </div>
    <div>
      <modal
        :show.sync="modals"
        v-model="noticeType"
        headerClasses="justify-content-center"
      >
        <h4 slot="header" class="title title-up">{{ noticeTitle }}</h4>
        <div>
          <base-input label="请输入公告内容：">
            <textarea
              ref="myTextarea"
              v-model="myTextareaValue"
              style="padding: 0"
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>
          </base-input>
          <div style="margin-top: 20px">
            公告颜色：
            <el-select
              class="select-danger"
              placeholder="Single Select"
              v-model="selects.simple"
            >
              <el-option
                v-for="option in selects.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <base-button
            type="secondary"
            @click="modals = false"
            style="margin-right: auto"
            >取消</base-button
          >
          <base-button
            type="primary"
            style="margin-left: auto"
            @click="doAddNotice"
            >确认</base-button
          >
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import Modal from "@/components/Modal";
import Swal from "sweetalert2";
import { Select, Option } from "element-ui";
import { http } from "../../util/http.js";
import { changeDateFormat, colorFun } from "../../util/utils.js";
export default {
  data() {
    return {
      colorFun,
      changeDateFormat,
      link: "",
      myTextareaValue: "",
      ipTextareaValue: "",
      modals: false,
      noticeId: 0,
      columns: ["id", "color", "content", "add_time", "actions"],
      BaseTable,
      tableData: [],
      noticeType: "",
      noticeTitle: "",
      username: "",
      expired: "",
      payImg: "",
      huaban_type: "",
      selects: {
        simple: "请选择公告颜色",
        languages: [
          { value: "#67C23A", label: "绿色" },
          { value: "#F56C6C", label: "红色" },
          { value: "#4169E1", label: "蓝色" },
          { value: "#EE00EE", label: "紫色" },
          { value: "#97FFFF", label: "青色" },
        ],
      },
    };
  },
  components: {
    BaseTable,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mounted() {
    this.getAuth();
  },
  methods: {
    // 触发文件选择
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    // 处理图片上传
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 检查是否为图片
      if (!file.type.startsWith("image/")) {
        this.$notify({
          type: "danger",
          message: "请选择图片文件",
          timeout: 2000,
        });
        return;
      }

      // 检查文件大小（例如限制为 5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$notify({
          type: "danger",
          message: "图片大小不能超过 5MB",
          timeout: 2000,
        });
        return;
      }

      // 将图片转换为 base64
      this.convertToBase64(file);

      // 清空 input，以便再次选择同一文件时能触发 change 事件
      event.target.value = "";
    },

    // 转换为 base64
    convertToBase64(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64String = e.target.result;
        // 如果需要纯 base64 数据（去掉前缀）
        const pureBase64 = base64String.split(",")[1];
        // 这里可以调用你的接口或做其他处理
        this.uploadImageToServer(base64String);
      };

      reader.onerror = (error) => {
        console.error("读取文件失败:", error);
        this.$notify({
          type: "danger",
          message: "读取图片失败",
          timeout: 2000,
        });
      };

      reader.readAsDataURL(file);
    },

    // 上传到服务器（可选）
    uploadImageToServer(base64Data) {
      http
        .post(
          "/v1/admin/updateImg",
          {
            img: base64Data,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          // 或者存储到 data 中
          this.imageBase64 = base64Data;
          this.getAuth();
          Swal.fire({
            icon: "success",
            html: "图片上传成功成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    getAuth() {
      http
        .get("/v1/admin/getAllNotice", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.tableData = res.data.data.notice;
          this.expired = res.data.data.expired;
          this.username = res.data.data.username;
          this.payImg = res.data.data.pay;
          this.ipTextareaValue = res.data.data.ipData;
          this.huaban_type = res.data.data.huaban_type;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    doAddNotice() {
      // 执行添加公告
      if (this.myTextareaValue == "") {
        this.$notify({
          type: "danger",
          message: "请输入公告内容",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      if (this.selects.simple == "请选择公告颜色") {
        this.$notify({
          type: "danger",
          message: "请选择公告颜色",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      if (this.noticeType == "addNotice") {
        http
          .post(
            "/v1/admin/addNotice",
            {
              content: this.myTextareaValue,
              color: this.selects.simple,
            },
            { headers: { adminToken: localStorage.getItem("adminToken") } }
          )
          .then((res) => {
            if (res.data.code != 200) {
              this.$notify({
                type: "danger",
                message: res.data.message,
                timeout: 2000,
                icon: "tim-icons icon-bell-55",
              });
              return;
            }
            this.modals = false;
            this.getAuth();
            Swal.fire({
              icon: "success",
              html: "公告添加成功",
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
          })
          .catch((error) => {
            console.error("发生错误:", error);
          });
      } else {
        http
          .post(
            "/v1/admin/editNotice",
            {
              id: this.noticeId,
              color: this.selects.simple,
              content: this.myTextareaValue,
            },
            { headers: { adminToken: localStorage.getItem("adminToken") } }
          )
          .then((res) => {
            if (res.data.code != 200) {
              Swal.fire({
                icon: "error",
                title: "公告编辑失败",
                text: res.data.message,
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
              return;
            }
            this.getAuth();
            this.modals = false;
            Swal.fire({
              icon: "success",
              html: "公告编辑成功",
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
          })
          .catch((error) => {
            console.error("发生错误:", error);
            // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
          });
      }
    },
    handleAddNotice() {
      // 添加公告按钮
      this.modals = true;
      this.myTextareaValue = "";
      this.noticeType = "addNotice";
      this.selects.simple = "请选择公告颜色";
      this.noticeTitle = "添加公告";
      this.$nextTick(() => {
        this.$refs.myTextarea.focus();
      });
    },
    editNotice(id, color, content) {
      // 编辑公告
      this.myTextareaValue = content;
      this.selects.simple = color;
      this.noticeId = id;
      this.modals = true;
      this.noticeType = "editNotice";
      this.noticeTitle = "编辑公告";
      this.$nextTick(() => {
        this.$refs.myTextarea.focus();
      });
    },
    deleteNotice(id) {
      // 删除公告
      Swal.fire({
        title: "删除公告",
        text: "确定需要删除该公告吗?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success btn-fill",
          cancelButton: "btn btn-danger btn-fill",
        },
        buttonsStyling: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((res) => {
        if (res.isConfirmed) {
          http
            .post(
              "/v1/admin/deleteNotice",
              {
                id: id,
              },
              { headers: { adminToken: localStorage.getItem("adminToken") } }
            )
            .then((res) => {
              if (res.data.code != 200) {
                Swal.fire({
                  icon: "error",
                  title: "公告删除失败",
                  text: res.data.message,
                  customClass: {
                    confirmButton: "btn btn-success btn-fill",
                  },
                  buttonsStyling: false,
                });
                return;
              }
              this.getAuth();
              Swal.fire({
                icon: "success",
                html: "公告删除成功",
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              console.error("发生错误:", error);
              // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
            });
        }
      });
    },
    handleDelete() {
      // 删除oss链接
      if (this.link === "") {
        this.$notify({
          type: "danger",
          message: "链接不能为空!",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      Swal.fire({
        title: "删除链接",
        text: "确定需要删除oss链接吗?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success btn-fill",
          cancelButton: "btn btn-danger btn-fill",
        },
        buttonsStyling: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((res) => {
        if (res.isConfirmed) {
          http
            .post(
              "/v1/admin/deleteOss",
              {
                link: this.link,
              },
              { headers: { adminToken: localStorage.getItem("adminToken") } }
            )
            .then((res) => {
              if (res.data.code != 200) {
                Swal.fire({
                  icon: "error",
                  title: "删除失败",
                  text: res.data.message,
                  customClass: {
                    confirmButton: "btn btn-success btn-fill",
                  },
                  buttonsStyling: false,
                });
                return;
              }
              Swal.fire({
                icon: "success",
                html: "删除成功",
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              console.error("发生错误:", error);
              // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
            });
        }
      });
    },
    updata123yunpan() {
      http
        .get("/v1/admin/login123YuePan", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.getAuth();
          Swal.fire({
            icon: "success",
            html: "123云盘更新成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    updateIp() {
      // 删除公告
      Swal.fire({
        title: "更改动态ip",
        text: "确定需要更改动态ip吗?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success btn-fill",
          cancelButton: "btn btn-danger btn-fill",
        },
        buttonsStyling: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((res) => {
        if (res.isConfirmed) {
          http
            .post(
              "/v1/admin/updateIp",
              {
                ipData: this.ipTextareaValue,
              },
              { headers: { adminToken: localStorage.getItem("adminToken") } }
            )
            .then((res) => {
              if (res.data.code != 200) {
                Swal.fire({
                  icon: "error",
                  title: "更改动态ip失败",
                  text: res.data.message,
                  customClass: {
                    confirmButton: "btn btn-success btn-fill",
                  },
                  buttonsStyling: false,
                });
                return;
              }
              this.getAuth();
              Swal.fire({
                icon: "success",
                html: "更改动态ip成功",
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              console.error("发生错误:", error);
              // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
            });
        }
      });
    },
    changeHuaBanState(){
      http
        .get("/v1/admin/updateHuaBan", {
          headers: { adminToken: localStorage.getItem("adminToken") },
        })
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.getAuth();
          Swal.fire({
            icon: "success",
            html: "花瓣下载类型更改成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
  },
};
</script>
<style >
.card-calendar {
  min-height: 400px;
}

.banner-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 8px; */
  flex-shrink: 0;
}

.huaban_type_header{
  display: flex;
  /* flex-direction: column; */
}

.banner-qrcode {
  width: 150px;
  height: 150px;
  border-radius: 12px;
  background: white;
  /* padding: 4px; */
}

.banner-qr-text {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.9;
}

.banner-right {
  flex: 1;
}
</style>
